import { CompanyUserFormScope } from 'mormaii-web-presentation/company-user-form'
import type { ViewFactory } from 'wdc-cube-solid'

import { CompanyUserFormView } from './v-company-user-form'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(CompanyUserFormScope, CompanyUserFormView)
}

export { CompanyUserFormView }
